export default __webpack_public_path__ + "850c4d14bbdeb15dd471eb77d8792169.png";